import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { API_BASE } from '@/lib/api';

// Same-origin URL so the auth cookie is included by the browser. Previous
// implementation used axios blob fetch (responseType: 'blob') which hangs
// indefinitely on mobile when crossing to a different eTLD+1.
export default function PostImage({ fileId, index, total }) {
  const [errored, setErrored] = useState(false);

  const aspectClass =
    total === 1 ? 'aspect-video'
    : total === 3 && index === 0 ? 'row-span-2 aspect-square'
    : 'aspect-square';

  if (!fileId || errored) {
    return (
      <div className={`${aspectClass} rounded-xl bg-stone-100 flex flex-col items-center justify-center text-stone-400 p-4`}>
        <ImageOff className="w-8 h-8 mb-2" />
        <span className="text-xs">{errored ? 'Failed to load' : 'No image'}</span>
      </div>
    );
  }

  return (
    <img
      src={`${API_BASE}/files/${fileId}`}
      alt="Post media"
      loading="lazy"
      decoding="async"
      className={`${aspectClass} rounded-xl object-cover w-full h-full`}
      onError={() => setErrored(true)}
      data-testid={`post-image-${index}`}
    />
  );
}
